import InternalStaticAnchor from 'models/application/anchor/types/internalStatic/InternalStatic';

export default class InternalStaticAnchorDashboard extends InternalStaticAnchor {
	_pattern = '/dashboard';
}
